import React, { Component } from "react";
import axios from "axios";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Row, Col } from "shards-react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../api";
import { withStyles } from "@material-ui/core/styles";
//import VehicleHistoryComponent from './VehicleHistory'
import HistoryIcon from "@material-ui/icons/History";
import Checkbox from "@material-ui/core/Checkbox";
import GoogleMapsSearchBoxStandalone from "./GoogleMapsSearchBoxStandalone";
import MenuItem from "@material-ui/core/MenuItem";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PersonAddDisabledIcon from "@material-ui/icons/PersonAddDisabled";
import Popover from "@material-ui/core/Popover";
import ViewIcon from "@material-ui/icons/Visibility";
import InputMask from "react-input-mask";

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      //      mask={['(', /[0-9]/, /\d/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      //      placeholderChar={'\u2000'}
      mask="(+99) - 99999 - 99999999"
      formatChars={{ "9": "[0-9]", "-": "[0-9-]", "?": "[0-9 ]" }}
      placeholderChar={"\u2000"}
      showMask
    />
  );
}
const useStyles = theme => ({
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  helperText: {
    fontWeight: 700,
    color: "orange",
    fontStyle: "italic",
    fontSize: "0.7rem"
  },
  checkbox: {
    width: 8,
    height: 8
  },
  menu: {
    fontSize: "0.75rem"
  }
});

class Vehicle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      vehicles: {
        loading: false,
        open: false,
        options: [{ plate: "" }]
      },
      vehicle: {
        plate: "",
        owner: "",
        description: "",
        last_gm: "",
        last_km_date: "",
        last_km_origin: "",
        is_fleet_owner: "",
        warranty_state: "",
        version: { name: "" },
        work_orders: [{ id: 1 }],
        location: { lat: "", lng: "", province: "", state: "" },
        is_estimated: false,
        km_confirmed: true,
        client: {
          business_name: ""
        },
        subcontacts: [
          {
            subcontact: {
              firstname: "",
              lastname: "",
              contact: { phone: "", email: "" }
            }
          }
        ],
        contact_name: "",
        contact_phone: "",
        contact_email: "",
        contact_new: false,
        driver_firstname: "",
        driver_lastname: "",
        driver_email: "",
        driver_phone: "",
        driver_new: false,
        contacts: [{}]
      },
      dialog: { open: false },
      searchTimeout: null,
      autocompleteLoading: true
    };

    this.handleVehicleAsyncChange = this.handleVehicleAsyncChange.bind(this);
  }

  componentDidMount() {
    var vehicle = this.props.vehicle;
    var vehicles = this.state.vehicles;
    if (vehicle.plate !== "") {
      vehicles.options[0].plate = vehicle.plate;
    }
    this.setState({ vehicle: vehicle, vehicles: vehicles });
  }

  handleVehicleAsyncChange = async (event, values) => {
    var vehicle = this.state.vehicle;
    values =
      values !== null
        ? values
        : {
            plate: "",
            owner: "",
            description: "",
            version: { name: "" },
            last_km: "",
            last_km_date: "",
            last_km_origin: "",
            is_fleet_owner: "",
            is_estimated: false,
            warranty_state: "",
            work_orders: [{ id: 1 }],
            location: { lat: "", lng: "", province: "", state: "" },
            contract: {
              contact: {
                client: {
                  business_name: ""
                },
                subcontacts: [{ id: "" }]
              }
            },
            subcontacts: [
              {
                subcontact: {
                  firstname: "",
                  lastname: "",
                  contact: { phone: "", email: "" }
                }
              }
            ],
            contact_name: "",
            contact_phone: "",
            contact_email: "",
            contact_id: "",
            contact_new: false,
            driver_firstname: "",
            driver_lastname: "",
            driver_email: "",
            driver_phone: "",
            driver_new: false,
            contacts: [{ id: "" }],
            active_booking: [],
            active_booking_related_vehicle: []
          };
    //vehicle = values
    vehicle.client = values.contract
      ? { business_name: values.contract.contact.client.business_name }
      : { business_name: "AutoCorp SA" };
    vehicle.contract = values.contract;
    vehicle.id = values.id;
    vehicle.plate = values.plate;
    vehicle.owner = values.owner;
    vehicle.version = { name: values.version.name };
    vehicle.km = values.last_km;
    vehicle.last_km = values.last_km;
    vehicle.last_km_date = values.last_km_date;
    vehicle.last_km_origin = values.last_km_origin;
    vehicle.is_fleet_owner = values.is_fleet_owner;
    vehicle.work_orders = values.work_orders;
    vehicle.warranty_state = values.warranty_state;
    vehicle.contacts = values.contract
      ? values.contract.contact.subcontacts
      : values.subcontacts;
    var subcontacts_autocorp = [];
    var contacts_autocorp = [];
    if (!values.contract && !vehicle.active_booking) {
      subcontacts_autocorp.push(await this.getAutoCorpDriver());
      values.subcontacts.push(subcontacts_autocorp[0].contact);
      vehicle.contacts = subcontacts_autocorp;
    }
    vehicle.subcontacts = values.subcontacts;
    vehicle.driver_new = values.subcontacts.length > 0 ? false : true;
    vehicle.contact_new = false;
    vehicle.location = this.props.vehicle.location;
    vehicle.active_booking =
      values.active_booking.length > 0 ? values.active_booking[0] : null;
    if (!vehicle.active_booking) {
      vehicle.active_booking =
        values.active_booking_related_vehicle.length > 0
          ? values.active_booking_related_vehicle[0]
          : null;
    }
    if (vehicle.active_booking) {
      vehicle.contact_new = false;
      vehicle.driver_new = false;
      if (vehicle.active_booking.subcontact) {
        vehicle.subcontacts[0] = {
          subcontact: vehicle.active_booking.subcontact
        };
      } else {
        vehicle.subcontacts = [];
        vehicle.driver_new = true;
        /*if (vehicle.active_booking.client.contact.subcontacts[0]){
					vehicle.subcontacts[0] = {subcontact: vehicle.active_booking.client.contact.subcontacts[0]}
				} else {
					vehicle.subcontacts = []
				}*/
      }
      vehicle.client = {
        business_name: vehicle.active_booking.client.business_name
      };
      vehicle.contacts = vehicle.active_booking.client.contact.subcontacts;
    }
    this.setState({ vehicle: vehicle });
    if (values.plate === "") {
      var vehicles = this.state.vehicles;
      vehicles.options = [{ plate: "" }];
      this.setState({ vehicles: vehicles });
    } else {
      this.props.onPlateChanged();
    }
  };

  handleVehicleAsyncSearch = (event, values) => {
    var plate = values;
    const token = localStorage.getItem("userToken");
    this.setState({ autocompleteLoading: true });
    // Cancela el timeout anterior
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    // Establece un nuevo timeout
    this.state.searchTimeout = setTimeout(() => {
      if (plate.length > 2) {
        axios
          .get(api.vehicles().autocomplete(plate), {
            headers: { Authorization: `Bearer ${token}` }
          })
          .then(res => {
            var vehicles = this.state.vehicles;
            vehicles.options = res.data;
            this.setState({ vehicles: vehicles, autocompleteLoading: false });
          })
          .catch(err => {
            console.log(err);
          });
      }
    }, 2000);
  };

  handleContactChange = (e, values) => {
    var contact = [];
    var vehicle = this.state.vehicle;
    if (values) {
      contact = vehicle.contacts.filter(obj => {
        return parseInt(obj.contact_id) === parseInt(values.contact_id);
      });
      if (!contact) {
        contact = vehicle.contacts.filter(obj => {
          return parseInt(obj.id) === parseInt(values.contact_id);
        });
      }
    } else {
      contact.push({
        id: "",
        email: "",
        phone: "",
        subcontact: { firstname: "", lastname: "" }
      });
    }
    if (contact[0].subcontact) {
      vehicle.contact_name =
        contact[0].subcontact.firstname + " " + contact[0].subcontact.lastname;
      vehicle.contact_email = contact[0].email ? contact[0].email : "";
      vehicle.contact_phone = contact[0].phone ? contact[0].phone : "";
      vehicle.contact_id = contact[0].id;
    } else {
      vehicle.contact_name = contact[0].firstname + " " + contact[0].lastname;
      vehicle.contact_email = contact[0].contact.email
        ? contact[0].contact.email
        : "";
      vehicle.contact_phone = contact[0].contact.phone
        ? contact[0].contact.phone
        : "";
      vehicle.contact_id = contact[0].contact.id;
    }

    this.setState({ vehicle });
  };

  handleChange = e => {
    var name = e.target.name;
    var value =
      name === "is_estimated" || name === "km_confirmed"
        ? e.target.checked
        : e.target.value;
    var vehicle = this.state.vehicle;
    if (name === "contact_name") {
      var contact = vehicle.contacts.filter(obj => {
        return obj.id === e.target.value;
      });
      if (!contact) {
        contact = vehicle.contacts.filter(obj => {
          return obj.contact_id === e.target.value;
        });
      }
      if (contact[0].subcontact) {
        vehicle.contact_name =
          contact[0].subcontact.firstname +
          " " +
          contact[0].subcontact.lastname;
        vehicle.contact_email = contact[0].email ? contact[0].email : "";
        vehicle.contact_phone = contact[0].phone ? contact[0].phone : "";
        vehicle.contact_id = contact[0].id;
      } else {
        vehicle.contact_name = contact[0].firstname + " " + contact[0].lastname;
        vehicle.contact_email = contact[0].contact.email
          ? contact[0].contact.email
          : "";
        vehicle.contact_phone = contact[0].contact.phone
          ? contact[0].contact.phone
          : "";
        vehicle.contact_id = contact[0].contact.id;
      }
    } else {
      if (name === "km") {
        vehicle["is_confirmed"] = false;
      }
      vehicle[name] = value;
    }
    this.setState({ vehicle });
  };

  handleDialog = () => {
    /*
			var dialog = this.state.dialog
			dialog.open = !dialog.open
			this.setState({dialog: dialog})
		*/
  };

  handleMapChange = location => {
    var vehicle = this.state.vehicle;
    vehicle.location = {
      lat: location.lat(),
      lng: location.lng(),
      province: location.province,
      state: location.state,
      address: location.address
    };
    this.setState({ vehicle: vehicle });

    this.props.onLocationChange(vehicle.location);
  };

  hasWorkOrders = work_orders => {
    var hasWorkOrders = false;
    if (work_orders.length > 0) {
      work_orders.map((val, idx) => {
        if (val.id !== this.props.work_order_id && val.id !== 0) {
          hasWorkOrders = true;
        }
      });
    }
    return hasWorkOrders;
  };

  handleAddContact = e => {
    var vehicle = this.state.vehicle;
    vehicle.contact_new = !vehicle.contact_new;
    vehicle.contact_email = "";
    vehicle.contact_phone = "";
    vehicle.contact_name = "";
    vehicle.contact_lastname = "";
    vehicle.contact_firstname = "";
    vehicle.contact_id = "";
    this.setState({ vehicle });
  };

  handleContactPopOver = (e, open) => {
    this.setState({ anchorElPopOver: open });
  };

  getAutoCorpDriver = async () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.contacts().dummyDriver(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };

  render() {
    const vehicles = this.state.vehicles;
    const vehicle = this.state.vehicle;
    const classes = this.props.classes;
    const anchorElPopOver = this.state.anchorElPopOver;
    const openPopOver = Boolean(anchorElPopOver);

    return (
      <React.Fragment>
        {/*<Dialog fullScreen open={this.state.dialog.open} onClose={this.handleDialog} >
					<AppBar className="mt-2" >
					  <Toolbar>
					    <IconButton edge="start" color="inherit" onClick={this.handleDialog} aria-label="close">
					      <CloseIcon />
					    </IconButton>
					    <Typography variant="h6" className={classes.title} style={{color:"white"}}>
					      Historial de {vehicle.plate}
					    </Typography>
					  </Toolbar>
					</AppBar>
					<VehicleHistoryComponent plate={this.state.vehicle.plate}/>
				</Dialog>*/}

        {this.props.work_order_id > 0 ? (
          <TextField
            id="plate"
            disabled
            name="plate"
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption" style={{ minWidth: 50 }}>
                    Patente{" "}
                  </Typography>
                </InputAdornment>
              )
            }}
            className="mr-2 mt-0"
            InputLabelProps={{
              shrink: true
            }}
            value={vehicle.plate}
            inputProps={{
              style: { fontSize: "0.75rem", width: 75 }
            }}
          />
        ) : (
          <Autocomplete
            id="plate"
            style={{ width: 125 }}
            disabled={this.props.work_order_id > 0 ? true : false}
            getOptionLabel={option => option.plate}
            getOptionSelected={(option, value) => option.plate === value}
            options={this.state.vehicles.options}
            loadingText={<Typography variant="caption">Buscando</Typography>}
            //loading={this.state.vehicles.loading}
            loading={this.state.autocompleteLoading}
            onInputChange={this.handleVehicleAsyncSearch}
            onChange={this.handleVehicleAsyncChange.bind(this)}
            autoComplete
            noOptionsText={
              <Typography variant="caption">Sin resultados</Typography>
            }
            name="plate"
            includeInputInList
            classes={{
              option: classes.option
            }}
            renderInput={params => (
              <TextField
                {...params}
                placeholder="Patente"
                //      	              error={(this.state.vehicle.work_orders[0]) ? true : false }
                FormHelperTextProps={{
                  className: classes.helperText
                }}
                helperText={
                  this.state.vehicle.plate !== "" &&
                  this.hasWorkOrders(this.state.vehicle.work_orders)
                    ? "El vehiculo ya tiene una OT cargada"
                    : false
                }
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {this.state.vehicles.loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  )
                }}
                InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                inputProps={{
                  ...params.inputProps,
                  style: { fontSize: "0.75rem", width: 90 }
                }}
              />
            )}
          />
        )}
        {vehicle.id ? (
          <ViewIcon
            fontSize="small"
            onClick={e => {
              window.open("/vehicle/edit/" + vehicle.id, "_blank");
            }}
          />
        ) : (
          ""
        )}
        <Typography
          className="ml-2"
          variant="caption"
          style={{
            width: 70,
            fontSize: "0.7rem",
            color: vehicle.is_fleet_owner ? "green" : "red"
          }}
        >
          {vehicle.is_fleet_owner !== ""
            ? vehicle.is_fleet_owner === "1" || vehicle.is_fleet_owner === 1
              ? "Flota Propia"
              : "Flota Terceros"
            : ""}
        </Typography>
        <TextField
          id="description"
          disabled
          name="description"
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ minWidth: 50 }}>
                  Vehículo{" "}
                </Typography>
                <HistoryIcon
                  fontSize="small"
                  onClick={e => {
                    window.open(
                      "/vehicle-history/" + this.state.vehicle.plate
                    ); /*this.handleDialog(e)*/
                  }}
                />
              </InputAdornment>
            )
          }}
          className="mr-2 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          value={vehicle.version.name}
          inputProps={{
            style: { fontSize: "0.75rem" }
          }}
        />
        <Typography
          variant="caption"
          style={{
            width: 70,
            fontSize: "0.7rem",
            color: vehicle.warranty_state === 1 ? "green" : "red"
          }}
        >
          {" "}
          {vehicle.warranty_state !== ""
            ? vehicle.warranty_state === 1
              ? "Garantía Activa"
              : "Garantía Vencida"
            : ""}
        </Typography>
        <TextField
          id="last_km"
          disabled
          name="last_km"
          margin="normal"
          className="mr-2 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          value={vehicle.last_km ? vehicle.last_km : "Sin dato"}
          inputProps={{ style: { width: 50, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">KM</Typography>
              </InputAdornment>
            )
          }}
        />
        {/*				<TextField
					id="last_km_date"
					disabled	
					name="last_km_date"
					margin="normal"
					className="mr-1 mt-0"
					InputLabelProps={{
						shrink: true
					}}
					type="date"
					value={vehicle.last_km_date}
					inputProps={{style:{width:110,fontSize: '0.75rem'}}}
		          	InputProps={{
			            startAdornment: <InputAdornment position="start" style={{minWidth: 75}}><Typography variant="caption" >Últ. fecha </Typography></InputAdornment>,
						}}
				/>
			*/}
        <TextField
          id="last_km_origin"
          disabled
          name="last_km_origin"
          margin="normal"
          className="mr-2 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          value={
            vehicle.last_km
              ? vehicle.last_km_origin + " " + vehicle.last_km_date
              : "Sin dato"
          }
          inputProps={{ style: { width: 125, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Origen </Typography>
              </InputAdornment>
            )
          }}
        />
        <TextField
          id="km"
          name="km"
          margin="normal"
          className="mr-1 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          onChange={this.handleChange}
          value={vehicle.km}
          inputProps={{ style: { maxWidth: 60, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ width: 70 }}>
                  KM Actual
                </Typography>
                <Checkbox
                  id="km_confirmed"
                  name="km_confirmed"
                  className={classes.checkbox}
                  onChange={this.handleChange}
                  value={vehicle.km_confirmed}
                  checked={vehicle.km_confirmed}
                  color="primary"
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
              </InputAdornment>
            )
          }}
        />
        <FormControlLabel
          className="mr-1 mb-0"
          control={
            <Switch
              size="small"
              id="is_estimated"
              name="is_estimated"
              value={vehicle.is_estimated}
              checked={vehicle.is_estimated}
              onChange={this.handleChange}
            />
          }
          label={<Typography variant="caption">Estimado</Typography>}
          labelPlacement="start"
        />
        <div className="row col-12"></div>
        <TextField
          id="client_name"
          disabled
          name="name"
          margin="normal"
          className="mr-2 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          value={vehicle.client.business_name}
          inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" style={{ minWidth: 50 }}>
                <Typography variant="caption">Cliente</Typography>
              </InputAdornment>
            )
          }}
        />
        {vehicle.active_booking ? (
          <TextField
            id="booking_id"
            disabled
            name="name"
            margin="normal"
            className="mr-2 mt-0"
            InputLabelProps={{
              shrink: true
            }}
            value={vehicle.active_booking.hansa_code}
            inputProps={{ style: { fontSize: "0.75rem", width: 70 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption"># Reserva</Typography>
                </InputAdornment>
              )
            }}
          />
        ) : (
          ""
        )}
        {vehicle.subcontacts[0] ? (
          <TextField
            id="driver_id_name"
            name="driver_id_name"
            disabled={true}
            placeholder="Ingrese el conductor"
            value={
              vehicle.subcontacts[0]
                ? vehicle.subcontacts[0].subcontact.firstname +
                  " " +
                  vehicle.subcontacts[0].subcontact.lastname
                : null
            }
            margin="normal"
            className="mr-1 mt-0"
            InputLabelProps={{
              shrink: true
            }}
            onChange={this.handleChange}
            inputProps={{ style: { fontSize: "0.75rem", width: 120 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption" style={{ minWidth: 30 }}>
                    Conductor{" "}
                  </Typography>
                </InputAdornment>
              ),
              endAdornment: <InputAdornment position="start"></InputAdornment>
            }}
          />
        ) : (
          <div>
            <TextField
              id="driver_firstname"
              name="driver_firstname"
              placeholder="Ingrese el nombre conductor"
              value={vehicle.driver_firstname}
              margin="normal"
              className="mr-1 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              //					value="Nombre apellido 1 (conductor@cliente.com) 1541616572"
              inputProps={{ style: { fontSize: "0.75rem", width: 150 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 30 }}>
                      Conductor{" "}
                    </Typography>
                  </InputAdornment>
                ),
                endAdornment: <InputAdornment position="start"></InputAdornment>
              }}
            />
            <TextField
              id="driver_lastname"
              name="driver_lastname"
              placeholder="Ingrese el apellido conductor"
              value={vehicle.driver_lastname}
              margin="normal"
              className="mr-1 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              //					value="Nombre apellido 1 (conductor@cliente.com) 1541616572"
              inputProps={{ style: { fontSize: "0.75rem", width: 120 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ minWidth: 30 }}>
                      Conductor{" "}
                    </Typography>
                  </InputAdornment>
                ),
                endAdornment: <InputAdornment position="start"></InputAdornment>
              }}
            />
          </div>
        )}
        <TextField
          id="driver_email"
          name="driver_email"
          placeholder="Ingrese el email conductor"
          disabled={!vehicle.driver_new}
          value={
            vehicle.subcontacts[0]
              ? vehicle.subcontacts[0].subcontact.contact
                ? vehicle.subcontacts[0].subcontact.contact.email
                : vehicle.subcontacts[0].email
              : vehicle.driver_email
          }
          margin="normal"
          className="mr-1 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          onChange={this.handleChange}
          //					value="Nombre apellido 1 (conductor@cliente.com) 1541616572"
          inputProps={{ style: { fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ minWidth: 30 }}>
                  Email{" "}
                </Typography>
              </InputAdornment>
            ),
            endAdornment: <InputAdornment position="start"></InputAdornment>
          }}
        />

        <TextField
          id="driver_phone"
          name="driver_phone"
          placeholder="Ingrese el telefono conductor"
          disabled={!vehicle.driver_new}
          value={
            vehicle.subcontacts[0]
              ? vehicle.subcontacts[0].subcontact
                ? vehicle.subcontacts[0].subcontact.contact
                  ? vehicle.subcontacts[0].subcontact.contact.phone
                    ? vehicle.subcontacts[0].subcontact.contact.phone.padStart(
                        15,
                        "0"
                      )
                    : ""
                  : vehicle.subcontacts[0].subcontact.phone
                : ""
              : vehicle.driver_phone
              ? vehicle.driver_phone.padStart(15, "0")
              : ""
          }
          margin="normal"
          className="mr-1 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          onChange={this.handleChange}
          inputProps={{ style: { fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ minWidth: 30 }}>
                  Telefono{" "}
                </Typography>
              </InputAdornment>
            ),
            endAdornment: <InputAdornment position="start"></InputAdornment>,
            inputComponent: TextMaskCustom
          }}
        />

        <div className="row col-12"></div>
        {this.props.work_order_id > 0 ? (
          <React.Fragment>
            <TextField
              id={"contact_name"}
              name={"contact_name"}
              disabled
              onChange={this.handleChange}
              value={vehicle.contact_name}
              margin="normal"
              className="mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption" style={{ width: 75 }}>
                      Contacto{" "}
                      <ViewIcon
                        fontSize="small"
                        onClick={e => {
                          this.handleContactPopOver(e, e.currentTarget);
                        }}
                      />
                    </Typography>
                  </InputAdornment>
                ),
                style: { fontSize: "0.75rem" }
              }}
            />
            <Popover
              id="provider_popover"
              open={openPopOver}
              anchorEl={anchorElPopOver}
              onClose={e => {
                this.handleContactPopOver(e, null);
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center"
              }}
            >
              <div className="p-2">
                <Row>
                  <Col>
                    <TextField
                      id="vehicle_contact_name"
                      name="vehicle_contact_name"
                      value={vehicle.contact_name}
                      margin="normal"
                      className="mr-2 mt-0"
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        style: { minWidth: 200, fontSize: "0.75rem" }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">Nombre</Typography>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextField
                      id="vehicle_contact_email"
                      name="vehicle_contact_email"
                      value={vehicle.contact_email}
                      margin="normal"
                      className="mr-2 mt-0"
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        style: { minWidth: 200, fontSize: "0.75rem" }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">Email</Typography>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextField
                      id="vehicle_contact_phone"
                      name="vehicle_contact_phone"
                      value={
                        vehicle.contact_phone
                          ? vehicle.contact_phone.padStart(15, "0")
                          : ""
                      }
                      margin="normal"
                      className="mr-2 mt-0"
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        style: { minWidth: 200, fontSize: "0.75rem" }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">Telefono</Typography>
                          </InputAdornment>
                        ),
                        inputComponent: TextMaskCustom
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <TextField
                      id="vehicle_contact_mobile"
                      name="vehicle_contact_mobile"
                      value={
                        vehicle.contact_mobile
                          ? vehicle.contact_mobile.padStart(15, "0")
                          : ""
                      }
                      margin="normal"
                      className="mr-2 mt-0"
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        style: { minWidth: 200, fontSize: "0.75rem" }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">Celular</Typography>
                          </InputAdornment>
                        ),
                        inputComponent: TextMaskCustom
                      }}
                    />
                  </Col>
                </Row>
              </div>
            </Popover>
          </React.Fragment>
        ) : this.state.vehicle.contact_new ? (
          <TextField
            id={"contact_firstname"}
            placeholder={"Ingrese el nombre del contacto"}
            name={"contact_firstname"}
            onChange={this.handleChange}
            value={vehicle.contact_fistname}
            margin="normal"
            className="mr-2 mt-0"
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption" style={{ width: 75 }}>
                    Contacto{" "}
                    {this.state.vehicle.contact_new ? (
                      <PersonAddDisabledIcon
                        onClick={e => {
                          this.handleAddContact(e);
                        }}
                      />
                    ) : (
                      <PersonAddIcon
                        onClick={e => {
                          this.handleAddContact(e);
                        }}
                      />
                    )}
                  </Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />
        ) : (
          <FormControlLabel
            className="mx-0 my-0"
            style={{ alignItems: "baseline" }}
            label={
              <Typography variant="caption" style={{ width: 75 }}>
                Contacto{" "}
                {this.state.vehicle.contact_new ? (
                  <PersonAddDisabledIcon
                    onClick={e => {
                      this.handleAddContact(e);
                    }}
                  />
                ) : (
                  <PersonAddIcon
                    onClick={e => {
                      this.handleAddContact(e);
                    }}
                  />
                )}
              </Typography>
            }
            labelPlacement="start"
            control={
              <Autocomplete
                id="contact_name"
                style={{ width: 225 }}
                getOptionLabel={option =>
                  option.firstname + " " + option.lastname
                }
                getOptionSelected={(option, value) =>
                  option.firstname === value
                }
                options={vehicle.contacts}
                onChange={this.handleContactChange.bind(this)}
                autoComplete
                noOptionsText={
                  <Typography variant="caption">Sin resultados</Typography>
                }
                name="contact_name"
                includeInputInList
                classes={{
                  option: classes.option
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    placeholder="Contacto"
                    id="contact_name"
                    name="contact_name"
                    autoComplete="off"
                    //      	              error={(this.state.vehicle.work_orders[0]) ? true : false }
                    FormHelperTextProps={{
                      className: classes.helperText
                    }}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {this.state.vehicles.loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      )
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "contact_name",
                      style: { fontSize: "0.75rem", width: 225 }
                    }}
                  />
                )}
              />
            }
          />
        )}

        {this.state.vehicle.contact_new ? (
          <TextField
            id="contact_lastname"
            placeholder="Ingrese el apellido del contacto"
            name="contact_lastname"
            onChange={this.handleChange}
            value={vehicle.contact_lastname}
            margin="normal"
            className="mr-2 mt-0"
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography variant="caption" style={{ width: 75 }}>
                    Contacto{" "}
                  </Typography>
                </InputAdornment>
              ),
              style: { fontSize: "0.75rem" }
            }}
          />
        ) : (
          ""
        )}
        <TextField
          id="contact_email"
          placeholder="Ingrese el email"
          onChange={this.handleChange}
          name="contact_email"
          value={vehicle.contact_email}
          disabled={!vehicle.contact_new}
          type="email"
          margin="normal"
          className="mr-2 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 90, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ minWidth: 50 }}>
                  Email
                </Typography>
              </InputAdornment>
            )
          }}
        />
        <TextField
          id="contact_phone"
          placeholder="Ingrese el telefono"
          name="contact_phone"
          onChange={this.handleChange}
          value={vehicle.contact_phone.padStart(15, "0")}
          disabled={!vehicle.contact_new}
          type="text"
          margin="normal"
          className="mr-2 mt-0"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 75, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption" style={{ minWidth: 50 }}>
                  Telefono{" "}
                </Typography>
              </InputAdornment>
            ),
            inputComponent: TextMaskCustom
          }}
        />
        <GoogleMapsSearchBoxStandalone
          height="300px"
          places={[]}
          disabled={false}
          zoom={15}
          onChange={this.handleMapChange}
          location={vehicle.location}
        />
        {/*(vehicle.location.lat !== '' && this.props.work_order_id !== '')
					 ?
						<TextField
							id="contact_location"
							name="contact_location"
							disabled={true}
							value={vehicle.location.address}
							type="text"
							margin="normal"
							className="mr-2 mt-0"
							InputLabelProps={{
								shrink: true
							}}
							inputProps={{style:{minWidth: 75, fontSize: '0.75rem'}}}
						  	InputProps={{
						        startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{minWidth: 50}}>Ubicación </Typography></InputAdornment>,
								}}
						/>

					 : 
						<GoogleMapsSearchBoxStandalone
							height='300px'
							places={[]}
							disabled={false}
							zoom={15}
							onChange={this.handleMapChange}
							location={vehicle.location}	
						/>

				 */}
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Vehicle);
